import { render } from "./BMI.vue?vue&type=template&id=428fa112&scoped=true&ts=true"
import script from "./BMI.vue?vue&type=script&lang=ts"
export * from "./BMI.vue?vue&type=script&lang=ts"

import "./BMI.vue?vue&type=style&index=0&id=428fa112&scoped=true&lang=less"

import exportComponent from "D:\\project\\mpe-project\\vue-project\\mobile-mpe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428fa112"]])

export default __exports__